import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { assembleLookbookQuery } from '~/helpers/extract-helper';

function fetchLookbook(_x, _x2) {
  return _fetchLookbook.apply(this, arguments);
}

function _fetchLookbook() {
  _fetchLookbook = _asyncToGenerator(function* (context, query) {
    var locale = context.state.i18n.currentLocale;
    var xhrUri = "/catalog/v1/lookbooks/catalog?culture=".concat(locale.language, "_").concat(locale.market, "&").concat(assembleLookbookQuery(query));
    var {
      data
    } = yield context.$axios.get(xhrUri);
    return data;
  });
  return _fetchLookbook.apply(this, arguments);
}

export { fetchLookbook as default };